export enum FindAllBookingsSort {
  BOOKING_NUMBER = 'bookingNumber',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  CREATED_DATE = 'createdDate',
  UPDATED_DATE = 'updatedDate',
  RELEVANT_DATE = 'relevantDate',
}
